import { render } from "./TermDetailVx.vue?vue&type=template&id=79869116&scoped=true"
import script from "./TermDetailVx.vue?vue&type=script&lang=js"
export * from "./TermDetailVx.vue?vue&type=script&lang=js"

import "./TermDetailVx.vue?vue&type=style&index=0&id=79869116&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79869116"]])

export default __exports__